import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import AddressInput from "Components/common/form/AddressInput";
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import utils from 'Utils/index.js';
import style from './style.scss';

import TimeSelect from 'Components/common/DeliveryTimeSelect/DeliveryTimeSelect';

export default class LeadForm extends Component {

  constructor(props) {
    super(props);

    const {app_data} = props;

    this.state = {
      device_type_id: "",
      problem_type_id: "",
      status_id: Object.keys(app_data.statuses)[0],

      first_call_by_id: '',
      created_by_id: '',
      confirmed_by_id: '',



      comment: '',
      model: '',

      delivery_address: '',
      delivery_brand: '',
      delivery_date: '',
      delivery_time: '',
      time_start: '00:00',
      time_end: '00:00',
      delivery_saving: false,

      lead_saving: false,
    };

  }

  deviceTypeChange = (e) => {

    this.setState({
      device_type_id: e.target.value
    });

  };

  problemTypeChange = (e) => {

    this.setState({
      problem_type_id: e.target.value
    });

  };

  statusChange = (e) => {

    this.setState({
      status_id: e.target.value
    });

  };

  firstCallByChange = (e) => {

    this.setState({
      first_call_by_id: e.target.value
    });

  };


  confirmedByChange = (e) => {

    this.setState({
      confirmed_by_id: e.target.value
    });

  };

  createdByChange = (e) => {

    this.setState({
      created_by_id: e.target.value
    });

  };

  modelChange = (e) => {

    this.setState({
      model: e.target.value
    });

  };

  commentChange = (e) => {

    this.setState({
      comment: e.target.value
    });

  };




  deliveryFormChange = (fields_values) => {

    this.setState(fields_values);

  };

  saveLead = () => {
    const {saveLead} = this.props;

    if(this.state.device_type_id === '') {
      alert('Не был установлен тип устройства');

      return;
    }

    console.log(this.state)
    if(this.state.problem_type_id === '') {
      alert('Не был установлен тип проблемы');

      return;
    }

    if(this.state.first_call_by_id === '') {
      alert('Не был установлен оператор принявший звонок');

      return;
    }

    if(this.state.delivery_address !== '' && this.state.created_by_id === '') {
      alert('Не установлен опертор в блоке доставки');

      return;
    }

    if(this.state.delivery_address !== '' && this.state.delivery_date === '') {
      alert('Не установлена дата доставки');

      return;
    }


    this.setState({
      lead_saving: true
    });

    const save_data = {
      device_type_id: this.state.device_type_id,
      problem_type_id: this.state.problem_type_id,
      status_id: this.state.status_id,
      model: this.state.model,
      comment: this.state.comment,
      delivery_time: [this.state.time_start, this.state.time_end].join('-'),
      delivery_date: this.state.delivery_date,
      delivery_address: this.state.delivery_address,
      delivery_brand: this.state.delivery_brand,
      delivery_to_client: !!this.props.lead.remonline_id,

    };

    if(this.state.first_call_by_id !== '') {
      save_data.first_call_by_id = this.state.first_call_by_id;
    }

    if(this.state.created_by_id !== '') {
      save_data.created_by_id = this.state.created_by_id;
    }

    if(this.state.confirmed_by_id !== '') {
      save_data.confirmed_by_id = this.state.confirmed_by_id;
    }

    saveLead(save_data).then(() => {
      // this.setState({
      //   lead_saving: false
      // });
    });

  };

  componentWillMount(){
    const {app_data: {device_types, problem_types, statuses}, saveLead, onClose, lead} = this.props;


    if(lead && typeof lead == 'object') {

      this.setState({
        device_type_id: lead.device_type_id || this.state.device_type_id,
        problem_type_id: lead.problem_type_id || this.state.problem_type_id,
        status_id: lead.status_id || this.state.status_id,
        model: lead.model,
        comment: lead.comment,

        first_call_by_id: lead.first_call_by_id || this.state.first_call_by_id,
        created_by_id: lead.created_by_id || this.state.created_by_id,
        confirmed_by_id: lead.confirmed_by_id || this.state.confirmed_by_id,
      });

    }
  }

  remonlineData() {

    let remonline_content;
    const {lead} = this.props;
    let title = 'Информация из Ремонт Онлайн';

    if(!this.props.lead.remonline_id) {
      remonline_content = this.deliveryForm();
      title = 'Добавить доставку';
    } else {
      remonline_content = this.deliveryForm(true);
      title = 'Добавить доставку к клиенту';

    }

    return (
      <div className="layout__row bottom_border">
        <div className="layout__col_4">
          <div className="form__label">
            {title}
          </div>
        </div>
        {remonline_content}
      </div>
    )
  }

  deliveryForm = (to_client) => {
    let {app_data: {operators}} = this.props;
    const date_options = [];
    
    for(let i = 0; i < 14; i++) {
      const delivery_date = moment().add(i, 'days');
      date_options.push({
        date: delivery_date.format(utils.DATE_FORMAT),
        date_text: delivery_date.format(utils.DATE_FORMAT)
      });
    }

    return (
      <div>

        <div className="layout__row bottom_border">
          <TimeSelect
            class_name="layout__col_4"
            onChange={this.deliveryFormChange}
            value_start={this.state.time_start}
            value_end={this.state.time_end}
          />

          <div className="layout__col_4">
            <div className="label">
              Дата
            </div>
            <div className="form__control">
              <select
                value={this.state.delivery_date}
                onChange={(e) => {
                  this.deliveryFormChange({
                    delivery_date: e.target.value
                  });
                }}
              >
                <option value={''} key={''}>Выбрать дату</option>
                {date_options.map(date => {
                  return <option value={date.date} key={date.date}>{date.date_text}</option>
                })}
              </select>

            </div>

          </div>

          {!to_client && <FormField
            label="Оператор"
            label_class="label"
            column_width={4}
            type="select"
            onChange={this.createdByChange}
            value={this.state.created_by_id}
            options={operators}
            empty={true}
          />}

        </div>

        {!to_client && (
          <>
            <div className="layout__row bottom_border">

              <div className="layout__col_12">

                <div className="label">
                  Адрес
                </div>

                <div className="form__control">
                  <AddressInput
                    onChange={(val) => {
                      this.deliveryFormChange({
                        delivery_address: val,
                      });
                    }}
                  />
                  {/*<input*/}
                  {/*  type="text"*/}
                  {/*  onChange={(e) => {*/}
                  {/*    this.deliveryFormChange({*/}
                  {/*      delivery_address: e.target.value*/}
                  {/*    });*/}
                  {/*  }}*/}
                  {/*  value={this.state.delivery_address}*/}
                  {/*/>*/}

                </div>
              </div>
            </div>

            <div className="layout__row bottom_border">
              <div className="layout__col_6">

                <div className="label">
                  Бренд
                </div>

                <div className="form__control">

                  <input
                    type="text"
                    onChange={(e) => {
                      this.deliveryFormChange({
                        delivery_brand: e.target.value
                      });
                    }}
                    value={this.state.delivery_brand}
                  />

                </div>

              </div>
            </div>
          </>
        )}


      </div>

    )
  }


  getProblemsByDevice(device_types, problem_types, deviceId) {
    const deviceType = device_types[deviceId];
    if(!deviceType) {
      return [];
    }
    const problemsIds = deviceType.problems;
    return problemsIds.reduce((acc, problemId) => {
      return {
        ...acc,
        [problemId]: problem_types[problemId]
      };
    }, {});
  }

  render() {

    let {app_data: {device_types, problem_types, statuses, operators}, saveLead, onClose, lead, client} = this.props;

    const lead_saving_class = this.state.lead_saving ? 'lead_form_saving' : '';

    const client_data = client || lead.client;
    console.log(device_types)
    const deviceTypes = {
      ...device_types
    }
    const problemTypes = this.getProblemsByDevice(device_types, problem_types, this.state.device_type_id);
    const first_row_column_width = 3;

    return (
      <div >

        <div className="modal__overlay" onClick={onClose}> </div>
        <div className="modal">

          <div className={`${lead_saving_class} modal__content`}>

            <div className="lead_form">

              <div className="layout__row bottom_border">

                <div className="layout__col_12">
                  {client_data && client_data.phone}
                  <span> </span>
                  {client_data && client_data.name}
                </div>

              </div>



              <div className="layout__row bottom_border">


                <FormField
                  label="Тип устройства"
                  column_width={first_row_column_width}
                  type="select"
                  onChange={this.deviceTypeChange}
                  value={this.state.device_type_id}
                  empty={true}
                  options={deviceTypes}
                />

                <FormField
                  label="Тип проблемы"
                  column_width={first_row_column_width}
                  type="select"
                  onChange={this.problemTypeChange}
                  value={this.state.problem_type_id}
                  options={problemTypes}
                  empty={true}
                />

                <FormField
                  label="Статус"
                  column_width={first_row_column_width}
                  type="select"
                  onChange={this.statusChange}
                  value={this.state.status_id}
                  options={statuses}
                />

                <FormField
                  label="Оператор"
                  column_width={first_row_column_width}
                  type="select"
                  onChange={this.firstCallByChange}
                  value={this.state.first_call_by_id}
                  disabled={lead.first_call_by_id && lead.first_call_by_id !== ''}
                  options={operators}
                  empty={true}
                />

              </div>


              <div className="layout__row bottom_border">
                <FormField
                  label="Бренд и модель"
                  column_width={12}
                  type="text"
                  onChange={this.modelChange}
                  value={this.state.model}
                />
              </div>




              {/*
                Комментарий
              */}
              <div className="layout__row bottom_border">

                <FormField
                  label="Комментарий"
                  column_width={12}
                  type="textarea"
                  onChange={this.commentChange}
                  value={this.state.comment}
                />

              </div>

              {/*
                Кем согласован заказ. По умолчанию пустое не выбран
              */}
              <div className="layout__row bottom_border">

                <FormField
                  label="Кем согласован(Дано первичное)"
                  column_width={6}
                  type="select"
                  onChange={this.confirmedByChange}
                  value={this.state.confirmed_by_id}
                  disabled={lead.confirmed_by_id && lead.confirmed_by_id !== ''}
                  options={operators}
                  empty={true}
                />

              </div>

              {this.remonlineData()}


              <div className="layout__row bottom_border">

                <div className="layout__col_12">
                  <div className="button button_green button_big lead_form__button" onClick={this.saveLead}>
                    Сохранить
                  </div>
                </div>



              </div>


            </div>

          </div>

        </div>

      </div>
    )
  }

}

const FormField = (
  {
    label,
    label_class,
    column_width,
    type,
    onChange,
    value,
    options,
    empty,
    disabled
  }
 ) => {

  let field;

  switch (type){
    case "select":
      field = <SelectField
        onChange={onChange}
        value={value}
        options={options}
        empty={empty}
        disabled={disabled}
      />;
      break;

    case "text":
      field = <TextField
        onChange={onChange}
        value={value}
      />;
      break;

    case "textarea":
      field = <TextareaField
        onChange={onChange}
        value={value}
      />;
      break;
  };

  const label_class_name = label_class || "form__label";

  return (
    <div className={`layout__col_${column_width}`}>

      <div className={label_class_name}>{label}</div>

      <div className="form__control">

        {field}

      </div>

    </div>
  )
};

const SelectField = (
  {
    onChange,
    value,
    options,
    empty,
    disabled
  }
) => {

  return (
    <select onChange={onChange} disabled={disabled} value={value}>
      {empty && <option value=""> </option>}
      {Object.keys(options).map(id => {
        const option_data = options[id];
        return <option value={id} key={id}>{option_data.title}</option>
      })}

    </select>
  );

};

const TextField = (
  {
    onChange,
    value
  }
) => {

  return (
    <input type="text" onChange={onChange} value={value}/>
  );

};

const TextareaField = (
  {
    onChange,
    value
  }
) => {

  return (
    <textarea rows="2" onChange={onChange} value={value}/>
  );

};